<template>
  <div class="base-form-content">
      <form-item v-for="(it,index) in list" :ref="it.itemConfig&&it.itemConfig.ref" :it="it" :model="model" :key="'it'+it.itemConfig.prop+index" />
  </div>
</template>

<script>
export default {
  name: 'BaseFormItem',
  props: ['list', 'model'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
  .base-form-content{
    display: flex;
    flex-wrap: wrap;
  }
</style>
